export enum TakeFiveRiskTypeEnum {
    Material = 1,
    NonMaterial = 2
}

export const TakeFiveRiskTypeEnumToString = ((option: TakeFiveRiskTypeEnum) => {
    switch (option) {
        case TakeFiveRiskTypeEnum.Material:
            return 'Material Risk:';
        case TakeFiveRiskTypeEnum.NonMaterial:
            return 'Non-Material Risk:';
        default: 'NA'
    }
});